import React from 'react'
import logoUrl from '../images/emmy_logoII.png'

export default class Logo extends React.Component {
  render() {
    return (
      <div id="logo">
        <img src={logoUrl} alt="Emmy" />
      </div>)
  }
}



// WEBPACK FOOTER //
// src/components/Logo.jsx